export function formatPrice(value) {
  if (value >= 10000000) {
    const cr = value / 10000000;
    return `${cr % 1 === 0 ? cr.toFixed(0) : cr.toFixed(1)}Cr`;
  }
  if (value >= 100000) {
    const l = value / 100000;
    return `${l % 1 === 0 ? l.toFixed(0) : l.toFixed(1)}L`;
  }
  if (value >= 1000) return `${(value / 1000).toFixed(0)}K`;
  return `${value}`;
}

export function formatPriceWithSymbol(value) {
  return `₹${formatPrice(value)}`;
}
